export type ServiceDraft = {
  serviceCategoryId: string;
  serviceCategoryLabel: string;
  materialOptionId: string | null;
  materialOptionLabel: string | null;
  shadeOptionId: string | null;
  shadeOptionLabel: string | null;
  translucencyOptionId: string | null;
  translucencyOptionLabel: string | null;
  blockSizeId: string | null;
  blockSizeLabel: string | null;
  manufacturingProcessId: string | null;
  manufacturingProcessLabel: string | null;
  characterizationOptionId: string | null;
  characterizationOptionLabel: string | null;
  finishingOptionId: string | null;
  finishingOptionLabel: string | null;
  teeth: string;
  /** Preço unitário; o serviço vale preço × quantidade. */
  priceCents: number | null;
  quantidade: number;
  notes: string | null;
  attachmentFileId: string | null;
  attachmentFileName: string | null;
};

/** "1.234,56" -> 123456 (centavos). null se vazio. */
export function parsePriceToCents(price: string): number | null {
  if (!price.trim()) return null;
  const cents = Math.round(parseFloat(price.replace(/\./g, "").replace(",", ".")) * 100);
  return Number.isFinite(cents) ? cents : null;
}

/** Toggle: clicar no já selecionado desmarca. */
export function toggleSelection(current: string | null, id: string): string | null {
  return current === id ? null : id;
}
